import { decodeHTML } from "../decodeHTML"

export const prepareDescription = (description: string) => {
    return decodeHTML(description)
    .replace(/<[^>]*>?/gm, '')
    .replace(/\r?\n|\r/, '');
}